export { LoadingPage } from './page.component';
